import { useState, useEffect } from "react";
import LogoImage from "../../../assets/images/logo.png";
import { Button } from "droplr-react-ui-v2";
import "./welcome-step.scss";
import { ONBOARDING_STEP } from "../../../constants/app.constants";

export interface WelcomeStepProps {
  SetCurrentStep: Function;
  UserFirstName: string;
  DataLoaded: boolean;
}

export const WelcomeStepComponent = ({
  SetCurrentStep,
  UserFirstName,
  DataLoaded,
}: WelcomeStepProps): JSX.Element => {
  return (
    <>
      {DataLoaded && (
        <div className="welcome-step step-component-container">
          <div className="logo-image fade-in-250">
            <img src={LogoImage} alt="Droplr Logo" />
          </div>
          <div className="welcome-user-text fade-in-250">
            {UserFirstName !== "" ? `Welcome ${UserFirstName}` : "Welcome"}
          </div>
          <div className="welcome-intro-text fade-in-250-500">
            Let’s personalize your Droplr experience in just 3 steps!
          </div>
          <div className="welcome-button fade-in-500-750">
            <Button
              variant="primary"
              label={"Let's begin"}
              
              
              onClick={() => {
                SetCurrentStep(ONBOARDING_STEP.WHO_IS_USING);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
